import moment from 'moment-timezone'


export const bookingMsg='You can not book this event as the start time is less than 5 hr from now.'

export const bookingAllowTime = (val) => {
    let parkingTime=val?.parking_start_time
    let timeduration=val?.booking_duration_hours
    let bookingAllow=false
    if(timeduration && timeduration>0 && timeduration!==null){
        let timeZone=val?.facilities?.[0]?.timezone ? val?.facilities?.[0]?.timezone :'America/New_York'
        let currentDt = moment().tz(timeZone).format('MM-DD-YYYY HH:mm:ss')
        let date = moment(parkingTime, 'YYYY-MM-DD HH:mm:ss').subtract(timeduration, 'h').format('MM-DD-YYYY HH:mm:ss')  
        if(moment(currentDt).isSameOrAfter(moment(date), 'minute')){
            bookingAllow=true
        }
    }
  
    
  return bookingAllow
  }